/* istanbul ignore file */
export * from './ProductHintsItem';
